import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchCPTrackDetails } from '../../actions/additional_actions';
import { getDateValue } from '../../utils/date';
import { formatMoney } from '../../utils/budget';
import { FaFileExcelO } from 'react-icons/lib/fa';
import { withAuth } from '../../actions/';

class CPDetails extends Component {
    // static PropTypes = {
    //     cpDetail: PropTypes.array.isRequired,
    // }

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
            itemsPerPage: 20
        }

        this.handleClick = this.handleClick.bind(this);
        this.changeNumItemsShown = this.changeNumItemsShown.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { projectId } = this.props;
        this.props.fetchCPTrackDetails(projectId);
        this.handleExportToExcel = this.handleExportToExcel.bind(this);

    }
    componentDidUpdate(prevProps) {
        if (prevProps.projectId !== this.props.projectId) {
            this.props.fetchCPTrackDetails(this.props.projectId, this.props.projectId);

        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.cpDetail !== nextProps.cpDetail)
            this.setState({ cpDetail: nextProps.cpDetail })
        if (this.props.projectId !== nextProps.projectId)
            this.setState({ projectId: nextProps.projectId })
    }

    handleClick(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
    }

    changeNumItemsShown(e) {
        if (e.target.value < 20 || e.target.value > this.props.cpDetail.length) {
            // || ((e.target.value > this.props.blueBooks.length/2) && (this.state.currentPage)) )
            //console.log(this.state.currentPage); 
        }
        else {
            this.setState({ itemsPerPage: e.target.value });
        }
    }

    handleExportToExcel() {

        // pass project Id 

        const projectId = this.props.projectId;


        let url = `projects/${projectId}/ExportCPTrackDetail`;
        let method = 'post';
        let responseType = 'arraybuffer';

        withAuth(
            { method, url, responseType },
            (response) => {
                var data = response.data;
                var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                var blob = new Blob([data], { type: contentType });
                var downloadUrl = window.URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = downloadUrl;
                link.download = 'CPTrackDetails.xlsx';
                link.click();
            },
            this.errorHandler
        )
    }

    render() {
        const { currentPage, itemsPerPage } = this.state;

        // Logic for displaying items
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentcpDetail = this.props.cpDetail.slice(indexOfFirstItem, indexOfLastItem);

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.props.cpDetail.length / itemsPerPage); i++) {
            pageNumbers.push(i);
        }
        return (
            <div id="blueBook">
                {currentcpDetail.length > 0 ?
                    <div className="row-wide">
                        <div className="col s12">
                        <button className="btn-save btn-excel float-right margin-top-035" onClick={this.handleExportToExcel}>
                                <span className="margin-right-05"> <FaFileExcelO size={18} color='#008000' /></span>
                                Excel</button>
                            <h4 className="bar-bottom">CP Information </h4>  
                        </div>
                        <div className="col s12">
                            <div className="table">
                                <table className="table-striped">
                                    <thead>
                                        <tr>
                                            <th>Source System</th>
                                            <th>FMS ID</th>
                                            <th>CP #</th>
                                            <th>Amended CP</th>
                                            <th>Blanket CP</th>
                                            <th>PM Requested Amount</th>
                                            <th>Approved Amount</th>
                                            <th>OMB CP Approval Date</th>
                                            <th>OMB CP Rejected Date</th>
                                            <th>OMB Sent Date</th>
                                            <th>Original CP Requested Date</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentcpDetail.map((cp, index) => {
                                            return <tr key={index}>
                                                <td>{cp.source}</td>
                                                <td>{cp.fms_id}</td>
                                                <td>{cp.cpid}</td>
                                                <td>{cp.is_amended}</td>
                                                <td>{cp.is_blanket_cp}</td>
                                                <td>{formatMoney(cp.pm_req_amt)}</td>
                                                <td>{formatMoney(cp.total_cp_approved_amt)}</td>
                                                <td>{getDateValue(cp.omb_cp_approval_dt)}</td>
                                                <td>{getDateValue(cp.omb_cp_rejected_dt)}</td>
                                                <td>{getDateValue(cp.omb_sent_dt)}</td>
                                                <td>{getDateValue(cp.orig_cp_req_bud_dt)}</td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {pageNumbers.length > 1 &&
                            <div>
                                <div className="col s12">
                                    <div className="controls margin-top-1">
                                        <label className="label-pagination">Show</label>
                                        <input type="number" value={itemsPerPage} onChange={this.changeNumItemsShown}
                                            min="2" max={this.props.cpDetail.length - 1} className="input-pagination" />
                                        <span className="label-pagination">Records</span>
                                    </div>
                                </div>

                                <div className="col s12">
                                    <div className="pagination-blue-book">
                                        <ul id="page-numbers">
                                            {pageNumbers.map(number => {
                                                return <li
                                                    key={number}
                                                    id={number}
                                                    onClick={this.handleClick}
                                                    className={currentPage === number ? 'active' : ''}
                                                >
                                                    {number}
                                                </li>
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                    </div> :
                   
                        <div className="noData">
                            No CP Information is found for this project.
          
                    </div>}
            </div>
        );
    }
}

CPDetails.propTypes = {
    cpDetail: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        cpDetail: state.additionalProjectsStore.cpDetail,
        projectId: ownProps.projectId,

    };
}

export default connect(mapStateToProps, { fetchCPTrackDetails })(CPDetails);